module.exports = __webpack_public_path__ + "fonts/sp-icons.ttf";